export default "__VITE_ASSET__B4$zo_Ng__"